import Model from './model';
import {RootSession} from './session';

let root = new RootSession();

root.Model = Model;

export default root;



// WEBPACK FOOTER //
// ./modules/cliser/src/index.js